// filepath: k:\SparrowHealth\luma-webapp\src\utils\pixel.js
const GA4_ID = "G-PTG75FV1B0";

export const trackGtagEvent = (eventName, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const payload = { ...params };
  delete payload.value;
  window.gtag("event", eventName, {
    ...payload,
    send_to: GA4_ID,
  });
};

export const FacebookPixel = {
    track: (event, data) => {
        if (window.fbq) {
            window.fbq('track', event, data);
        }
    },
    
    trackCustom: (event, data) => {
        if (window.fbq) {
            window.fbq('trackCustom', event, data);
        }
    }
};